module.exports = __webpack_public_path__ + "r-v3/img/ml_20_00.3e1d2835.jpg";